// Tracks the ONE supervisor evaluation the user may have walked away from.
// The report page writes an entry when it starts waiting; the dashboard watcher
// polls it and pops a "your report is ready" toast. Plain localStorage on
// purpose — no global state library, survives navigation and reloads.

export type PendingEval = {
  sessionId: number;
  patient?: string | null;
  caseId?: string | null;
  // Set once the report has landed but the student hasn't acknowledged the toast
  // yet, so navigating to another page re-opens on "hazır" instead of flashing
  // "hazırlanıyor" again while the status is re-checked.
  ready?: boolean;
};

const KEY = "pp_pending_eval";

export function setPendingEval(entry: PendingEval): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(entry));
  } catch {
    /* storage unavailable (private mode) — the report page still polls */
  }
}

export function getPendingEval(): PendingEval | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (typeof parsed?.sessionId !== "number") return null;
    return parsed as PendingEval;
  } catch {
    return null;
  }
}

/** Clear the entry — optionally only when it matches `sessionId`, so a report
 * page for an older session never wipes a newer pending evaluation. */
export function clearPendingEval(sessionId?: number): void {
  try {
    if (sessionId !== undefined) {
      const current = getPendingEval();
      if (current && current.sessionId !== sessionId) return;
    }
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
